(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("react"), (function webpackLoadOptionalExternalModule() { try { return require("moment"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define("commons-core-services", ["_", "react", "moment"], factory);
	else if(typeof exports === 'object')
		exports["commons-core-services"] = factory(require("lodash"), require("react"), (function webpackLoadOptionalExternalModule() { try { return require("moment"); } catch(e) {} }()));
	else
		root["CommonsCoreServices"] = factory(root["_"], root["React"], root["moment"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_moment__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition